import fixtureTypes from '../fixtureTypes'

const heads = [
  {
    value: ':/FIXTURES/HEADS/HEAD00',
    label: 'Head00',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head00.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD01',
    label: 'Head01',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head01.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD02',
    label: 'Head02',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head02.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD03',
    label: 'Head03',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head03.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD04',
    label: 'Head04',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head04.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD05',
    label: 'Head05',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head05.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD06',
    label: 'Head06',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head06.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD07',
    label: 'Head07',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head07.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD08',
    label: 'Head08',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head08.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD09',
    label: 'Head09',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head09.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD10',
    label: 'Head10',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head10.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD11',
    label: 'Head11',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head11.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD12',
    label: 'Head12',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head12.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD13',
    label: 'Head13',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head13.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD14',
    label: 'Head14',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head14.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD15',
    label: 'Head15',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head15.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD16',
    label: 'Head16',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head16.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD17',
    label: 'Head17',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head17.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD18',
    label: 'Head18',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head18.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD19',
    label: 'Head19',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head19.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD20',
    label: 'Head20',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head20.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD21',
    label: 'Head21',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head21.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD22',
    label: 'Head22',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head22.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD23',
    label: 'Head23',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head23.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD24',
    label: 'Head24',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head24.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD25',
    label: 'Head25',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head25.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD26',
    label: 'Head26',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head26.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD27',
    label: 'Head27',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head27.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD28',
    label: 'Head28',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head28.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/HEADS/HEAD29',
    label: 'Head29',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Heads-Head29.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const scans = [
  {
    value: ':/FIXTURES/SCANS/ROBE_SCAN250XT',
    label: 'Robe_Scan250XT',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Robe_Scan250XT.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN00',
    label: 'Scan00',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan00.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN01',
    label: 'Scan01',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan01.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN02',
    label: 'Scan02',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan02.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN03',
    label: 'Scan03',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan03.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN04',
    label: 'Scan04',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan04.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN05',
    label: 'Scan05',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan05.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN06',
    label: 'Scan06',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan06.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN07',
    label: 'Scan07',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan07.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN08',
    label: 'Scan08',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan08.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/SCANS/SCAN09',
    label: 'Scan09',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Scans-Scan09.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const trads = [
  {
    value: ':/FIXTURES/TRADS/CHANGER',
    label: 'Changer',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Changer.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR01',
    label: 'Par01',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par01.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR02',
    label: 'Par02',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par02.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR03',
    label: 'Par03',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par03.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR04',
    label: 'Par04',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par04.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR05',
    label: 'Par05',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par05.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR06',
    label: 'Par06',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par06.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR07',
    label: 'Par07',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par07.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR08',
    label: 'Par08',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par08.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR09',
    label: 'Par09',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par09.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR10',
    label: 'Par10',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par10.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR11',
    label: 'Par11',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par11.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR12',
    label: 'Par12',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par12.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR13',
    label: 'Par13',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par13.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR14',
    label: 'Par14',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par14.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR15',
    label: 'Par15',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par15.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR16',
    label: 'Par16',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par16.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/TRADS/PAR17',
    label: 'Par17',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Trads-Par17.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const leds = [
  {
    value: ':/FIXTURES/LEDS/LED',
    label: 'Led',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Leds-Led.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

const rollers = [
  {
    value: ':/FIXTURES/ROLLERS/ROBE_CLUBROLLER 150,250 CT',
    label: 'Robe_ClubRoller 150,250 CT',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Rollers-Robe_ClubRoller 150,250 CT.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
  {
    value: ':/FIXTURES/ROLLERS/ROLLER',
    label: 'Roller',
    asset: {
      src: 'Images/Icons/profilebuilder/3d/Rollers-Roller.png',
      class: 'pb-properties-details-model-selection-list-preview',
    },
  },
]

// TODO: seems identical to scans but is it ?
const multi = scans.map((scan) => ({ ...scan }))

const fixtures = [
  {
    label: 'Head',
    value: fixtureTypes.HEAD,
    models: heads,
  },
  {
    label: 'Scan',
    value: fixtureTypes.SCAN,
    models: scans,
  },
  {
    label: 'Trad',
    value: fixtureTypes.TRAD,
    models: trads,
  },
  {
    label: 'LED',
    value: fixtureTypes.LED,
    models: leds,
  },
  {
    label: 'Roller',
    value: fixtureTypes.ROLLER,
    models: rollers,
  },
  {
    label: 'Multi',
    value: fixtureTypes.MULTI,
    models: multi,
  },
]

export default fixtures
